import { render } from "./CvtagArea.vue?vue&type=template&id=10a23df6&scoped=true"
import script from "./CvtagArea.vue?vue&type=script&lang=js"
export * from "./CvtagArea.vue?vue&type=script&lang=js"

import "./CvtagArea.vue?vue&type=style&index=0&id=10a23df6&scoped=true&lang=css"

import exportComponent from "/home/hkohashi/webinar-master-php83/frontend-system/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10a23df6"]])

export default __exports__